import { make } from 'vuex-pathify';

const getDefaultState = () => {
  return {
    drawer: null,
    mini: false,
    items: [
      {
        title: 'Dashboard',
        icon: 'mdi-view-dashboard-variant',
        to: '/',
      },
      {
        title: 'Metering Data',
        icon: 'mdi-format-list-bulleted-triangle',
        to: '/metering-data',
      }
    ],
    credit:
    {
      title: 'Credit Billing',
      icon: 'mdi-home-city',
      to: '/credit-billing',
    },
    additionalNav: [
      {
        title: 'Downloads',
        icon: 'mdi-cloud-download',
        to: '/downloads',
      }
    ]
  }
}

const state = getDefaultState();

const mutations = {
  ...make.mutations(state),
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
};

const actions = {
  resetAppState ({ commit }) {
    commit('resetState')
  },
  init ({ dispatch }) {
    dispatch('resetAppState');
    dispatch('auth/resetAuthState', null, {root: true})
    dispatch('dashboard/resetDashboardState', null, {root: true})
    dispatch('endpoints/resetEndpointState', null, {root: true})
    dispatch('loader/resetLoaderState', null, {root: true})
    dispatch('notification/resetNotificationState', null, {root: true})
    dispatch('creditBilling/resetCreditBillingState', null, {root: true})
    dispatch('downloads/resetDownloadState', null, {root: true})
  }
};

const getters = {
  navItems: (state, getters, rootState, rootGetters) => {
    let nav = state.items;
    if (rootGetters['auth/isClientBilling']) {
      nav.push(state.credit);
    }
    return nav;
  }
};

export const app = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
